export default "__VITE_ASSET__DVx_CwG7__"